import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GlobalServices } from '../global.services';
import { SubscriptionPlanService } from '../services/subscription-plan.service';
declare var $: any;

@Component({
  selector: 'app-membership',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.scss']
})
export class MembershipComponent implements OnInit {

  constructor(
    private globalServices:GlobalServices,
    private subscriptionPlanService: SubscriptionPlanService,
    private router: Router
  ) { }
  showButtonForPlanPageRoute;
  subscriptionForMoveToPlan = new Subscription;
  ngOnInit(): void {
    if(this.globalServices?.isBrowser){
      // console.log('ngOnInit_MembershipComponent');
      this.globalServices?.hideHeader.next(false);
      this.globalServices?.hideFooter.next(false);
      this.slickSlider();
      this.getSubscriptionPlan();

      this.showButtonForPlanPageRoute = localStorage.getItem('moveToPlanPage') == 'false' ? false : true ;
      this.subscriptionForMoveToPlan = this.globalServices?.moveToPlanPage.subscribe((isChanged: any) =>{
        // console.log('ngOnInit_Subject_moveToPlan', isChanged); 
        if(isChanged == false){
          this.showButtonForPlanPageRoute = false;
        }
      })
      this.scrolltoTop();
    }
  }
  slideConfigForInstructor={};
  slideConfigForVideos = {};
  slideConfigForClients = {};
  instructorData = [
    { 
      imgSrc:"../../assets/images/instructors/renay.jpg",
      name:"Renay Wright",
      designation:"Yoga Teacher"
    },
    { 
      imgSrc:"../../assets/images/instructors/Michelle-Boss.png",
      name:"Michelle Boss",
      designation:"Personal Finance Coach"
    },
    { 
      imgSrc:"../../assets/images/Sharmila.jpg",
      name:"Sharmila Acharya",
      designation:"Mind-Body Flow Expert"
    },
    { 
      imgSrc:"../../assets/images/instructors/Kathryn.png",
      name:"Kathryn Chess",
      designation:"Nutritionist & Healthy Living Coach"
    },
  ]
  quickViewImages = [
    { imgSrc: "../../assets/images/quickView/1.jpg" },
    { imgSrc: "../../assets/images/quickView/2.jpg" },
    { imgSrc: "../../assets/images/quickView/3.jpg" },
    { imgSrc: "../../assets/images/quickView/4.jpg" },
    { imgSrc: "../../assets/images/quickView/5.jpg" },
    { imgSrc: "../../assets/images/quickView/6.jpg" },
    { imgSrc: "../../assets/images/quickView/7.jpg" },
    { imgSrc: "../../assets/images/quickView/8.jpg" },
    { imgSrc: "../../assets/images/quickView/9.jpg" },
    { imgSrc: "../../assets/images/quickView/10.jpg" },
  ]
  slickSlider() {
    this.slideConfigForInstructor = {
      "slidesToShow": 4,
      "slidesToScroll": 1,
      "infinite": false,
      "responsive": [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots:true,
            centerMode: true,
            centerPadding: '10px',
          },
        }
      ]
    }
    this.slideConfigForVideos = {
      "slidesToShow": 5,
      "slidesToScroll": 1,
      "infinite": true,
      arrows: false,
      dots:true,
      centerMode: true,
      centerPadding: '200',
      "responsive": [
        {
          breakpoint: 1539,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots:true,
            infinite: true,
            centerMode: true,
            centerPadding: '200px',
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '80px',
            arrows: false,
            dots:true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots:true,
            centerMode: true,
            centerPadding: '10px',
          },
        }
      ]
    }
    this.slideConfigForClients = {
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "infinite": false,
      "responsive": [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 676,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        }, 
      ]
    }
  }

  public accordianChange(index:number):void{
    if(this.globalServices.isBrowser){
    let els:any = document.getElementsByClassName('accordian');
    if(els){
     let el:any = document.getElementsByClassName('accordian')[index];
     if(el.classList.contains('active')){
      el.classList.remove("active");
     }else{
    for(let elem of els){
      elem.classList.remove("active");
    }
     el.classList.add("active");
     }
    }
   }
  }
  plan = "Monthly Plan"; //Premium Plan
  planSelected(indexPassed){
    if(indexPassed == 0){
      this.plan = "Monthly Plan";
    }
    if(indexPassed == 1){
      this.plan = "Premium Plan";
    }
    let elements  = document.getElementsByClassName('userPlanSection');
    for(let i=0; i < elements?.length ; i++){
      if(i == indexPassed){
        if(elements[i]?.classList.contains("active")){

        }
        else{
          elements[i]?.classList.add("active")
        }
      }
      else{
        elements[i]?.classList.remove("active")
      }
    }
  }

  planInfo;
  getSubscriptionPlan(){
    if(this.globalServices?.isBrowser){
      const token = localStorage.getItem('Token') ? localStorage.getItem('Token') : "";
      this.subscriptionPlanService?.getSubscriptionDetail().subscribe((response: any) => {
        if(response){
          console.log('response', response);
          this.planInfo = response;
        }
      })
    }
  }
  popUpMessage;
  clickOnPlan(idPassed){
    // console.log('clickOnPlan',this.plan, idPassed, this.plan == "Monthly Plan")
    if(idPassed){
      if(this.plan == "Premium Plan"){
        this.router.navigate([`register/${idPassed}-yearly`])
      }
      if(this.plan == "Monthly Plan"){
        this.router.navigate([`register/${idPassed}-monthly`])
      }
    }
    else{
      this.showAlert = true;
      this.popUpMessage = "Something went wrong. Please try again !!"
    }
  }
  goToThreeMonthSubscription(){
    // console.log('goToThreeMonthSubscription', this.plan);
    this.plan = "Monthly Plan";
    setTimeout(() => {
      this.clickOnPlan(this.planInfo?.data?._id);
    }, 200);
  }
  showAlert = false;
  public triggerCloseEvent() {
    this.showAlert = false;
  }
  scrollToViewOfExploreSection(){
    if(this.globalServices?.isBrowser){
      document.getElementById("exploreAWorldOfWellness").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
  }
  ngOnDestroy(){
    this.subscriptionForMoveToPlan.unsubscribe();
  }
  scrolltoTop(){
    if (this.globalServices.isBrowser) {
      // $('.enquirytop').click(() => {
        $('html, body').animate({
          scrollIntoView: $('#membershipPage').offset().top
        }, 1000);
      // });
    }
  }
  monthlyPlanSelected(idPassed){
    setTimeout(() => {
      if(idPassed){
        if(this.plan == "Premium Plan"){
          this.router.navigate([`register/${idPassed}-yearly`])
        }
        if(this.plan == "Monthly Plan"){
          this.router.navigate([`register/${idPassed}-monthly`])
        }
      }
      else{
        this.showAlert = true;
        this.popUpMessage = "Something went wrong. Please try again !!"
      }
    }, 500);
  }
}
